module.exports = __webpack_public_path__ + "img/more.cf8509f5.svg";